// Rich content for sub-pages.
// Keyed by the item.key from lib/navigation.js.
// Shape:
//   tagline: short italic phrase shown after the hero
//   intro: 1 to 2 paragraphs
//   sections: [{ title, body?, list?, quote? }]
//   closing: italic closing line
//
// If a page is not present here, SubPage falls back to the generic teaser layout.

export const SUBPAGE_CONTENT = {
  // ----- LE BATI -----
  "charpente-zinguerie": {
    tagline:
      "Le toit est la première des protections d'un bâtiment et de l'humain. « Avoir un toit sur la tête. »",
    intro: [
      "Pour construire ou rénover un toit, il y a des règles de l'art que nous ne négligeons pas. Nous vous garantissons la pérennité de l'ouvrage et de son étanchéité, à l'air comme à l'eau, grâce à de nouvelles générations de membranes spécialisées qui favorisent la respiration de votre maison, le tout sans fuite.",
      "Charpente traditionnelle ou fermette, neuf ou rénovation : nous adaptons nos techniques au lieu et à votre projet."
    ],
    sections: [
      {
        title: "Charpente et couverture",
        body:
          "Réfection, extension ou modification de votre toiture avec des matériaux durables et de qualité. Couverture en tuiles plates, oméga, ardoises, bacs aciers ou autres matériaux selon les régions : tout est possible."
      },
      {
        title: "Bandeaux sur mesure",
        body:
          "Création ou réfection de vos habillages de bandeau, sur mesure : tôle, aluminium, PVC ou bois, avec une palette de couleurs et de finitions infinies, afin que votre maison soit en harmonie avec vous-même."
      },
      {
        title: "Zinguerie",
        body:
          "Pièce majeure de l'étanchéité pour garantir la pérennité de votre bâti et l'évacuation des eaux de pluie : chéneaux, descentes, habillage de cheminée, étanchéité Velux (certification)."
      }
    ],
    closing:
      "Pérennité, étanchéité, respiration : un toit qui protège et accompagne votre maison."
  },

  menuiseries: {
    tagline:
      "Les ouvertures jouent un rôle essentiel dans le confort thermique, la lumière naturelle, l'identité architecturale du lieu et l'arrivée de l'énergie dans la maison.",
    intro: [
      "Nous vous proposons des solutions de menuiseries performantes et esthétiques, adaptées à votre projet : fenêtres, portes d'entrée, baies vitrées, coulissants, volets bois ou autres, volets roulants, portes de garage.",
      "Chez Rozier Concept, chaque installation est pensée pour optimiser l'isolation thermique, l'étanchéité, les apports solaires, le confort d'été et l'harmonie du bâtiment avec ses habitants."
    ],
    sections: [
      {
        title: "Menuiseries extérieures",
        body:
          "Les dimensions sur mesure sont calculées en fonction de l'emplacement, de l'utilisation et possèdent une mesure vibratoire spécifique. Rien n'est dimensionné au hasard."
      },
      {
        quote:
          "« Nous sommes des bâtisseurs et non des constructeurs. »"
      },
      {
        title: "Agencement intérieur",
        body:
          "Nous réalisons des agencements sur mesure alliant fonctionnalité, esthétique et cohérence des volumes : cuisine, escalier, rangements, dressings, bibliothèque, mobilier intégré."
      },
      {
        title: "Une approche Feng Shui habitat",
        body:
          "Notre approche, fondée sur un audit Feng Shui habitat, privilégie les matériaux nobles, les lignes équilibrées et une circulation fluide des espaces, pour créer des intérieurs chaleureux, intemporels et sur mesure."
      }
    ],
    closing:
      "Lumière, énergie, harmonie : la juste ouverture, à la juste place."
  },

  isolation: {
    tagline:
      "L'isolation thermique par l'extérieur et l'isolation des combles ou rampants comptent aujourd'hui parmi les solutions les plus efficaces pour améliorer durablement les performances d'un bâtiment.",
    intro: [
      "Chez Rozier Concept, nous privilégions les matériaux biosourcés, naturels et perspirants, pour améliorer le confort hiver comme été, limiter les déperditions thermiques, protéger le bâti, valoriser le patrimoine et réduire les consommations énergétiques, en neuf comme en rénovation performante."
    ],
    sections: [
      {
        title: "Matériaux biosourcés",
        body:
          "Nous travaillons notamment avec la laine et la fibre de bois, le chanvre et le liège. Des matières qui respirent et qui durent."
      },
      {
        title: "Crépis à la chaux",
        body:
          "Nos crépis sont des enduits à la chaux, déclinés dans une palette de couleurs variée, adaptés au support afin d'être pleinement respirants."
      },
      {
        title: "Bardages ventilés",
        body:
          "Notre approche prend également en compte le confort d'été, l'inertie du bâtiment et la qualité globale de l'enveloppe pour des résultats cohérents et durables."
      }
    ],
    closing:
      "Une enveloppe pensée comme une seconde peau : qui protège, qui respire et qui dure."
  },

  "ossature-bois": {
    tagline:
      "Le bois permet une architecture moderne, performante et durable.",
    intro: [
      "Chez Rozier Concept Bâti, nous travaillons avec des bois de qualité, tous issus de l'exploitation durable de la forêt, ainsi qu'avec d'autres matériaux performants, modernes et durables.",
      "Le bois offre rapidité de mise en œuvre, confort thermique et liberté architecturale, sans renoncer à la beauté."
    ],
    sections: [
      {
        title: "Maisons ossature bois",
        body:
          "L'emplacement est pensé en fonction de la cohérence environnementale. Ces constructions allient performance énergétique (isolation biosourcée) et respiration de la maison, étudiées pour votre confort de vie, la qualité des matériaux (sans PFC pour les OSB, voir les certifications) et une intégration harmonieuse dans leur environnement. Très rapides à monter par rapport à un bâti maçonné, en bois massif pour les montants ou en monobloc."
      },
      {
        quote:
          "« Osez allier le confort, le bois et la rapidité d'exécution. »"
      },
      {
        title: "Carports",
        body:
          "Des structures élégantes et robustes, sur mesure, pour protéger vos véhicules tout en valorisant votre extérieur."
      },
      {
        title: "Pergolas",
        body:
          "Espaces de transition entre intérieur et extérieur. Conçues sur mesure pour créer confort, bien-être, ombrage et esthétique. Bois ou autres matériaux, couleurs variées, bioclimatiques ou non, selon vos envies et selon l'étude personnalisée de cohérence environnementale du lieu."
      },
      {
        title: "Terrasses",
        body:
          "Terrasses bois ou autres matériaux performants et durables (imitation bois garantie plusieurs années, avec vis apparentes ou non), chaleureuses, adaptées à votre mode de vie et à l'architecture de votre habitation. Possibilité d'autres matériaux comme le grès."
      },
      {
        title: "Bardage",
        body:
          "Le bardage ventilé protège, isole et transforme l'esthétique d'un bâtiment, en tenant compte du confort d'été. Solutions contemporaines et durables, adaptées à chaque projet : bardage vertical, horizontal (avec ou sans vis apparentes), panneaux bois ou métal, joints debout."
      }
    ],
    closing:
      "Couleur, forme, matière : un bâti vivant, qui dialogue avec son paysage."
  },

  "renovation-energetique": {
    tagline:
      "Rénover ne se résume pas à remplacer des matériaux. Il s'agit de repenser l'ensemble du fonctionnement thermique et du confort du lieu.",
    intro: [
      "Rozier Concept vous accompagne dans une vision globale de la rénovation énergétique. Notre approche privilégie des solutions cohérentes, durables et adaptées à l'usage réel du bâtiment."
    ],
    sections: [
      {
        title: "Notre vision globale",
        list: [
          "Amélioration de l'enveloppe thermique",
          "Traitement des ponts thermiques",
          "Confort d'été",
          "Ventilation",
          "Isolation performante",
          "Optimisation des consommations"
        ]
      }
    ],
    closing:
      "Un projet réussi est avant tout un projet pensé dans sa globalité."
  },

  // ----- LE PAYSAGE -----
  conception: {
    tagline:
      "Avant toute réalisation, nous concevons des projets paysagers qui permettent de visualiser précisément les futurs aménagements.",
    intro: [
      "Cette étape donne une vision claire, cohérente et durable du projet avant sa mise en œuvre. Vous validez un projet structuré et anticipé, pas une approximation."
    ],
    sections: [
      {
        title: "Études et livrables",
        list: [
          "Plans d'implantation",
          "Croquis d'ambiance",
          "Modélisations 2D et 3D",
          "Organisation des circulations",
          "Répartition des végétaux et des matériaux",
          "Mise en valeur des perspectives",
          "Intégration du bâti dans son environnement"
        ]
      }
    ],
    closing:
      "Voir le projet avant qu'il n'existe : une exigence de cohérence et de durabilité."
  },

  structuration: {
    tagline:
      "Une clôture ne sert pas uniquement à délimiter un terrain. Elle participe à la protection, à l'intimité et à l'équilibre général du lieu.",
    intro: [
      "Nous structurons les espaces extérieurs avec le même soin que le bâti : chaque limite, chaque passage, chaque ouverture est pensé pour structurer sans enfermer, et révéler le lieu sans l'alourdir."
    ],
    sections: [
      {
        title: "Notre travail porte sur",
        list: [
          "L'intégration esthétique des clôtures",
          "Les portails et accès",
          "Les séparations végétales",
          "Les jeux de transparence et d'ouverture",
          "L'équilibre entre protection et respiration visuelle"
        ]
      }
    ],
    closing:
      "Structurer sans cloisonner, protéger sans isoler : le juste équilibre du seuil."
  },

  "cours-chemins": {
    tagline:
      "Les circulations extérieures jouent un rôle fondamental dans la lecture d'un lieu.",
    intro: [
      "Un chemin guide naturellement les déplacements et influence inconsciemment la manière dont on perçoit un espace. Les formes, les matériaux et les tracés sont étudiés pour favoriser une circulation fluide et naturelle."
    ],
    sections: [
      {
        title: "Nos réalisations",
        list: [
          "Allées piétonnes",
          "Accès véhicules",
          "Cours extérieures",
          "Chemins paysagers",
          "Zones de transition entre intérieur et extérieur"
        ]
      }
    ],
    closing:
      "Un chemin bien tracé n'est pas un détail : c'est une manière d'habiter le lieu."
  },

  "amenagements-paysagers": {
    tagline:
      "Chaque terrain possède une identité unique. Notre objectif est de révéler son potentiel en créant des aménagements cohérents avec l'architecture, l'environnement et le mode de vie des occupants.",
    intro: [
      "Le végétal devient ici un véritable outil de composition et d'équilibre. Le minéral, le bois et la pierre l'accompagnent pour créer des ambiances naturelles et harmonisées."
    ],
    sections: [
      {
        title: "Nos projets intègrent",
        list: [
          "Végétaux et massifs",
          "Minéral et pierre naturelle",
          "Bois et matériaux biosourcés",
          "Jeux de relief et de volumes",
          "Espaces de détente et de contemplation",
          "Ambiances végétales harmonisées"
        ]
      }
    ],
    closing:
      "Révéler le potentiel d'un lieu plutôt que lui imposer une forme."
  },

  "amenagements-exterieurs": {
    tagline:
      "Nous concevons des espaces extérieurs pensés pour être à la fois fonctionnels, esthétiques et durables.",
    intro: [
      "Chaque aménagement est étudié dans une logique d'ensemble afin de préserver l'harmonie du lieu, du seuil de la maison jusqu'aux confins du terrain."
    ],
    sections: [
      {
        title: "Nos interventions",
        list: [
          "Terrasses",
          "Pergolas bioclimatiques",
          "Espaces de vie extérieurs",
          "Zones de réception",
          "Espaces bien-être",
          "Éclairage extérieur",
          "Intégration paysagère des équipements"
        ]
      }
    ],
    closing:
      "Des extérieurs à vivre, en cohérence avec votre habitat et votre paysage."
  },

  jardins: {
    tagline:
      "Le jardin est pensé comme une extension naturelle de l'habitat. Il doit apporter équilibre, respiration et sensation de bien-être au quotidien.",
    intro: [
      "Chaque jardin est imaginé comme un lieu vivant, évolutif, profondément connecté à son environnement naturel."
    ],
    sections: [
      {
        title: "Selon les projets, nous concevons",
        list: [
          "Jardins contemporains",
          "Jardins naturels",
          "Jardins Feng Shui",
          "Jardins minéraux",
          "Jardins d'inspiration japonaise",
          "Espaces méditatifs et contemplatifs"
        ]
      }
    ],
    closing:
      "Un jardin vivant, qui évolue avec vous et avec le lieu."
  },

  // ----- L'ÉNERGÉTIQUE -----
  geobiologie: {
    tagline:
      "La géobiologie appliquée analyse les interactions entre le lieu, son environnement naturel et les personnes qui l'occupent.",
    intro: [
      "Chaque terrain possède ses propres caractéristiques : relief, circulation de l'eau, orientation, réseaux naturels, humidité, exposition ou perturbations environnementales. Cette étape constitue la base de toute réflexion énergétique cohérente."
    ],
    sections: [
      {
        title: "Cette lecture du site permet de comprendre",
        list: [
          "Les zones de stagnation ou de tension",
          "Les déséquilibres liés au terrain",
          "Les circulations naturelles du lieu",
          "L'impact de l'environnement sur le confort ressenti",
          "La cohérence entre implantation, habitat et paysage"
        ]
      }
    ],
    closing:
      "Lire avant d'agir : un terrain bien compris révèle des potentiels qu'aucun plan standard n'aurait identifiés."
  },

  "feng-shui-paysage": {
    tagline:
      "Le Feng Shui paysage travaille sur la relation entre l'environnement extérieur et l'énergie globale du lieu.",
    intro: [
      "La forme du terrain, les reliefs, les ouvertures visuelles, les circulations d'eau ou encore la végétation influencent directement l'équilibre d'un espace. Cette approche permet de concevoir des extérieurs harmonieux, cohérents et profondément intégrés à leur environnement."
    ],
    sections: [
      {
        title: "Notre analyse porte sur",
        list: [
          "Les formes du paysage",
          "Les axes de circulation énergétique",
          "Les protections naturelles du terrain",
          "Les ouvertures et perspectives",
          "L'équilibre entre vide et matière",
          "Le rapport entre le bâti et son environnement naturel"
        ]
      }
    ],
    closing:
      "Le paysage comme partenaire, jamais comme contrainte."
  },

  "feng-shui-habitat": {
    tagline:
      "Le Feng Shui de l'habitat vise à créer un intérieur fluide, équilibré et agréable à vivre.",
    intro: [
      "Chaque espace influence inconsciemment les comportements, les émotions et la qualité de vie quotidienne. L'organisation des volumes, les matériaux, les couleurs et les circulations jouent un rôle essentiel dans cette harmonie.",
      "L'objectif est de révéler le potentiel du lieu tout en respectant son identité architecturale."
    ],
    sections: [
      {
        title: "L'étude peut porter sur",
        list: [
          "L'implantation des pièces",
          "Les flux de circulation",
          "Les volumes et proportions",
          "Les couleurs et matières",
          "L'équilibre Yin et Yang",
          "Les cinq éléments",
          "La position des espaces clés",
          "L'ambiance énergétique générale du lieu"
        ]
      }
    ],
    closing:
      "Un habitat vivant, où chaque pièce respire à la juste mesure."
  },

  "feng-shui-business": {
    tagline:
      "Un espace professionnel influence directement la dynamique d'une entreprise, la qualité des échanges et la perception des clients.",
    intro: [
      "Le Feng Shui du business consiste à analyser l'environnement professionnel pour optimiser la cohérence du lieu avec l'activité et les humains qui y travaillent.",
      "Cette approche peut s'appliquer aux bureaux, commerces, cabinets, ateliers, restaurants, espaces de réception ou entreprises souhaitant développer un environnement plus cohérent et performant."
    ],
    sections: [
      {
        title: "Nous optimisons",
        list: [
          "La place du dirigeant",
          "Les flux de circulation",
          "L'accueil et l'image de l'entreprise",
          "Les espaces de décision",
          "Les zones de travail",
          "Le bien-être salarial",
          "Les circulations clients",
          "L'équilibre entre concentration et dynamisme",
          "La cohérence entre activité et environnement"
        ]
      }
    ],
    closing:
      "Un lieu bien pensé devient un véritable support au développement humain, professionnel et architectural."
  },

  "dragon-eau": {
    tagline:
      "Dans le Feng Shui ancestral, l'eau représente le mouvement, la circulation et la prospérité. Le Dragon d'Eau symbolise la manière dont cette énergie se déplace dans un environnement.",
    intro: [
      "Comprendre ces dynamiques permet d'orienter intelligemment l'aménagement d'un terrain et de renforcer l'équilibre global du lieu."
    ],
    sections: [
      {
        title: "Cette lecture s'appuie sur",
        list: [
          "Les mouvements naturels de l'eau",
          "Les écoulements du terrain",
          "Les formes du paysage",
          "Les courbes et lignes de force",
          "Les bassins, piscines et points d'eau",
          "Les axes de circulation énergétique"
        ]
      }
    ],
    closing:
      "L'eau, fil conducteur invisible de la prospérité d'un lieu."
  }
};

// Hub-level (section) introduction content, shown between the hero and the items grid.
// Keyed by section.key.
export const HUB_CONTENT = {
  paysage: {
    overline: "Rozier Concept Végétal",
    tagline:
      "Le paysage influence profondément notre manière de vivre un lieu.",
    paragraphs: [
      "Une circulation mal pensée, des volumes déséquilibrés, une implantation incohérente ou un environnement mal structuré peuvent créer une sensation d'inconfort, de tension ou de désordre visuel.",
      "À l'inverse, un aménagement réfléchi révèle le potentiel d'un terrain, améliore le confort quotidien et crée une véritable harmonie entre l'humain, le bâti et la nature.",
      "Chez Rozier Concept, chaque projet extérieur est pensé comme un ensemble cohérent où le végétal, les matériaux, les circulations et les énergies naturelles dialoguent entre eux."
    ]
  },
  energetique: {
    overline: "Rozier Concept Énergie",
    tagline:
      "L'énergie d'un lieu ne relève ni du hasard ni d'une approche superficielle.",
    paragraphs: [
      "Chaque terrain, chaque habitation et chaque espace professionnel possède une structure invisible qui influence profondément le confort, les sensations, les échanges et la manière de vivre un lieu au quotidien.",
      "Notre approche repose sur une vision globale mêlant lecture environnementale, Feng Shui ancestral et compréhension des interactions entre l'humain, le bâti et son environnement.",
      "L'objectif n'est pas de transformer un lieu par des artifices décoratifs, mais de travailler sur sa structure profonde afin de retrouver cohérence, fluidité et équilibre."
    ]
  }
};
